import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'

export const getInvestmentsReq = (action) => {
    const { societyId, status, search, fromDate, toDate, page, limit, investment_type, maturing_within_days } = action?.data || {};
    const url = apiEndpoints.GET_INVESTMENTS_API.replace(':societyId', societyId);
    const params = {};
    if (status && status !== 'all') params.status = status;
    if (investment_type && investment_type !== 'all') params.investment_type = investment_type;
    if (maturing_within_days) params.maturing_within_days = maturing_within_days;
    if (search) params.search = search;
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    if (page) params.page = page;
    if (limit) params.limit = limit;
    return axiosInstance.get(url, { params });
}

export const getInvestmentDetailsReq = (action) => {
    const { societyId, id } = action?.data || {};
    const url = apiEndpoints.GET_INVESTMENT_DETAILS_API
        .replace(':societyId', societyId)
        .replace(':id', id);
    return axiosInstance.get(url);
}

export const createInvestmentReq = (action) => {
    const { societyId, onSuccess, ...payload } = action?.data || {};
    const url = apiEndpoints.CREATE_INVESTMENT_API.replace(':societyId', societyId);
    return axiosInstance.post(url, payload);
}

export const updateInvestmentReq = (action) => {
    const { societyId, id, onSuccess, ...payload } = action?.data || {};
    const url = apiEndpoints.UPDATE_INVESTMENT_API
        .replace(':societyId', societyId)
        .replace(':id', id);
    return axiosInstance.put(url, payload);
}

export const deleteInvestmentReq = (action) => {
    const { societyId, id } = action?.data || {};
    const url = apiEndpoints.DELETE_INVESTMENT_API
        .replace(':societyId', societyId)
        .replace(':id', id);
    return axiosInstance.delete(url);
}

export const calculateInvestmentPreviewReq = (action) => {
    const { onSuccess, ...payload } = action?.data || {};
    return axiosInstance.post(apiEndpoints.CALCULATE_INVESTMENT_PREVIEW_API, payload);
}

export const matureInvestmentReq = (action) => {
    const { societyId, id, onSuccess, ...payload } = action?.data || {};
    const url = apiEndpoints.MATURE_INVESTMENT_API
        .replace(':societyId', societyId)
        .replace(':id', id);
    return axiosInstance.post(url, payload);
}

export const preMatureInvestmentReq = (action) => {
    const { societyId, id, onSuccess, ...payload } = action?.data || {};
    const url = apiEndpoints.PRE_MATURE_INVESTMENT_API
        .replace(':societyId', societyId)
        .replace(':id', id);
    return axiosInstance.post(url, payload);
}

export const renewInvestmentReq = (action) => {
    const { societyId, id, onSuccess, ...payload } = action?.data || {};
    const url = apiEndpoints.RENEW_INVESTMENT_API
        .replace(':societyId', societyId)
        .replace(':id', id);
    return axiosInstance.post(url, payload);
}
